// assets/header.js
// Header smart-sticky (estilo Headroom):
//  - barra fixa; no topo fica logo abaixo da announcement bar
//  - ao DESCER a pagina: esconde (translateY(-100%))
//  - ao SUBIR a pagina: aparece na hora (sem precisar voltar ao topo)
// O drawer mobile e controlado pelo script inline em header.liquid (.exp-drawer--open).

(function () {
  const header = document.querySelector('[data-header]');           // .exp-header
  if (!header) return;
  const bar = header.querySelector('.exp-header__bar');
  const spacer = header.querySelector('[data-header-spacer]');
  const marquee = document.querySelector('.exp-marquee');           // announcement bar
  if (!bar) return;

  const DELTA = 4;            // ignora micro-scroll
  let lastY = window.scrollY;
  let ticking = false;

  function barHeight() { return bar.offsetHeight || 60; }
  function annHeight() { return marquee ? marquee.offsetHeight : 0; }

  function syncSpacer() {
    if (spacer) spacer.style.height = barHeight() + 'px';
  }

  function update() {
    const y = window.scrollY;
    const ann = annHeight();

    if (y <= ann) {
      // ainda na regiao da announcement: barra logo abaixo dela, sempre visivel
      bar.style.top = (ann - y) + 'px';
      bar.classList.remove('is-hidden');
    } else {
      bar.style.top = '0px';
      if (y > lastY + DELTA) {
        bar.classList.add('is-hidden');       // descendo -> esconde
      } else if (y < lastY - DELTA) {
        bar.classList.remove('is-hidden');     // subindo -> mostra na hora
      }
    }
    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  syncSpacer();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { syncSpacer(); update(); }, { passive: true });
})();
